export default [
	{
		slug: 'yam-box',
		cssClass: 'yambox',
		name: 'Yam-Box',
		previewText: 'Food delivery service',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/yam-box/preview_front.png',
		tags: [
			'Websites',
			'Online Stores',
			'Applications',
			'SMM',
			'Design',
			'Banners',
			'Branding',
			'Marketing',
		],
		logo: '/img/projects/yam-box/logo.svg',
		content: `
      <p>
        <b>Delicious food delivery (pizza, rolls)</b> <br>
        The company was established with a franchise concept for further development. <a href="https://yam-box.ru" target="_blank">Yam-box.ru</a> 2018 - present.
      </p>
      <ul>
        <li>Developed a new website - application by technology <b>Google PWA</b></li>
        <li>Conversion to order <b>increased by 30%</b> and continues to grow</li>
        <li>A new website and applications open in 1.5-3 seconds, which is <b>? 4 times faster</b> than the old one.</li>
      </ul>
    `,
		domen: 'Yam-box.ru',
		site: 'https://yam-box.ru',
		appstore: 'https://apps.apple.com/us/app/yambox/id1491755448?l=ru&ls=1',
		googleplay:
			'https://play.google.com/store/apps/details?id=ru.forzik.yambox',
		desktopImg: '/img/projects/yam-box/desktop-1.png',
		iphoneImg: '/img/projects/yam-box/iphone-2.png',
		androidImg: '/img/projects/yam-box/android-1.png',
		aboutList: [
			{
				icon: '/img/projects/good-idea.svg',
				title: 'Product idea',
				text: 'First of all, we were interested in company founder and brand creator - Vadim. We started working with him to create idea of better delivery service for <u>delicious</u> food.',
			},
			{
				icon: '/img/projects/complex-approach.svg',
				title: 'A complex approach',
				text: 'We started with a comprehensive audit and agreed to work in several directions at once: website, applications, social networks, advertising in Yandex and Google, CEO, flyers design, banners in VKontakte and posts, video advertising for TV and YouTube.',
			},
			{
				icon: '/img/projects/marketing.svg',
				title: 'Marketing strategy',
				text: `
          For us, food delivery niche was a new marketing direction. We started with a full audit of the market situation and propose several hypotheses.In the first two months we launched test ads on Yandex, Google, VK and Instagram. Then connected SEO and SMS mailing.
          <br><br>
          Tests have shown that the weak point of the service is user-unfriendly site and applications. We agreed to create new ones within 5 months.
        `,
			},
			{
				icon: '/img/projects/seo.svg',
				title: 'Results (January 2022)',
				text: `
          <b>VK (Russian online social media):</b><br>
          1. Increased the number of sales through VK in six months. Now it is FIVE times more.<br>
          2. Reduced the cost of attracting a client to 80-218 rubles.<br>
          3. Implemented online newsletter for subscribers with monthly turnover of more than 100,000 rubles.<br>
          4. Increased the number of active subscribers from 15,000 to 25,000.<br>
          5. Were the first in the city who implement a VK shopping cart and begin receiving orders through it.<br>
          <br>
          <b>Website and Apps:</b><br>
          1. Basing on marketing analysis we developed a modern SPA website and two applications with simple and functional design.<br>
          2. Set up full integration of website and applications with the Aiko erp <i>(enterprise resource planning)</i> system.<br>
          3. Increased the number of sales from the app and website by 3 times. Profit still rising.<br>
          4. New website and applications open in 1.5-3 seconds - this is 4 times faster than the old versions.
        `,
			},
		],
	},
	{
		projectLink: 'https://new.pandakemerovo.ru/',
		cssClass: 'panda',
		name: 'Panda',
		previewText: 'Food delivery service',
		// previewDescription: '',
		// previewBgImg_back: '/img/projects/panda/preview_back.png',
		previewBgImg_front: '/img/projects/panda/preview_front.png',
		tags: [
			'Applications',
			'Online Stores',
			'Branding',
			'Design',
			'Marketing',
		],
	},
	{
		projectLink:
			'https://play.google.com/store/apps/details?id=info.markergroup.android&hl=ru',
		cssClass: 'marker',
		name: 'Marker',
		previewText: 'Analytics and monitoring service',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/marker/preview_back.png',
		previewBgImg_front: '/img/projects/marker/preview_front.png',
		tags: ['Applications', 'An innovative product', 'Design'],
	},
	{
		projectLink: 'https://www.ros-color.ru/',
		cssClass: 'roscolor',
		name: 'Ros-Color',
		previewText: 'No. 1 Textile Russian Factory ',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/roscolor/preview_back.jpg',
		previewBgImg_front: '/img/projects/roscolor/preview_front.png',
		tags: [
			'Websites',
			'Marketing',
			'SEO',
			'Design',
			'Banners',
			'Online Stores',
		],
	},
	{
		projectLink: 'https://vfinterior.ru/',
		cssClass: 'vfinterior',
		name: 'VFinterior',
		previewText: 'Interior Design',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/vfinterior/preview_front.png',
		tags: [
			'Websites',
			'Landing pages',
			'Tilda Development',
			'Logo Design',
			'Design',
			'Marketing',
		],
	},
	{
		projectLink: 'https://apps.apple.com/ru/app/id1523496529',
		cssClass: 'mkm-app',
		name: 'Moscabelmet',
		previewText: 'Cable production manufacturer',
		// previewDescription: '',
		previewBgImg_back: ' ',
		previewBgImg_front: '/img/projects/mkm-app/logo.svg',
		tags: ['Applications', 'An innovative product'],
	},
	{
		projectLink: 'https://t.me/MkmRuBot?start',
		cssClass: 'mkm-bot',
		name: 'Moscabelmet',
		previewText: 'Chat bot for a cable production factory',
		// previewDescription: '',
		previewBgImg_back: ' ',
		previewBgImg_front: '/img/projects/mkm-bot/telegram-logo.svg',
		tags: ['Chatbots'],
	},
	{
		projectLink: 'https://luckydo.ru/',
		cssClass: 'luckydo',
		name: 'Lucky Do',
		previewText: 'Food delivery service',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/luckydo/preview_back.png',
		previewBgImg_front: '/img/projects/luckydo/preview_front.png',
		tags: ['Websites', 'Online Stores', 'Design', 'Banners'],
	},
	{
		projectLink: 'http://biovillage.globalcode.eu/',
		cssClass: 'biovillage-app',
		name: 'Biòvillage',
		previewText: 'Product delivery service',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/biovillage-app/preview_front.png',
		tags: [
			'Applications',
			'Online Stores',
			'Branding',
			'Design',
			'Marketing',
			'Logo Design',
		],
	},
	{
		projectLink: 'https://caristo.ru/ ',
		cssClass: 'caristo',
		name: 'Caristo',
		previewText: 'Auto parts marketplace',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/caristo/preview_back.jpg',
		previewBgImg_front: '/img/projects/caristo/preview_front.png',
		tags: [
			'Marketplaces',
			'Websites',
			'Design',
			'Branding',
			'Marketing',
			'Logo Design',
		],
	},
	{
		projectLink: 'https://stokel.ru/',
		cssClass: 'stokel',
		name: 'Stokel',
		previewText: 'Building materials store',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/stokel/preview_front.png',
		tags: ['Websites', 'Online Stores', 'Design', 'Marketing'],
	},
	{
		projectLink: 'http://biovillage.globalcode.eu/',
		cssClass: 'biovillage-landing',
		name: 'Biòvillage',
		previewText: 'LP for product delivery service',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/biovillage-landing/preview_front.svg',
		tags: ['Landing pages', 'Marketing', 'Logo Design', 'Design', 'Branding'],
	},
	{
		projectLink: 'https://ohotta.ru/',
		cssClass: 'ohotta',
		name: 'Ohotta',
		previewText: 'Marketplace',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/ohotta/preview_front.png',
		tags: [
			'Marketplaces',
			'Innovative product',
			'Websites',
			'SMM',
			'Landing pages',
			'Design',
			'Branding',
			'Logo Design',
		],
	},
	{
		projectLink: 'https://barel.by/',
		cssClass: 'barel',
		name: 'Barel',
		previewText: 'Shoe cupboards store',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/barel/preview_back.png',
		previewBgImg_front: '/img/projects/barel/preview_front.png',
		tags: ['Websites', 'Landing pages', 'Design', 'Tilda Development'],
	},
	{
		projectLink: 'https://space.globalcode.eu/',
		cssClass: 'place-to-space',
		name: 'PlaceToSpace',
		previewText: 'Cosmic scale special project',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/place-to-space/preview_back.jpg',
		previewBgImg_front: '/img/projects/place-to-space/preview_front.png',
		tags: [
			'Websites',
			'Landing pages',
			'Innovative product',
			'SMM',
			'Design',
			'Branding',
			'Multilingual website',
		],
	},
	{
		projectLink: 'https://its-yug.ru/',
		cssClass: 'its-yug',
		name: 'ITS Yug',
		previewText: 'Calculator and website',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/its-yug/preview_back.jpg',
		previewBgImg_front: '/img/projects/its-yug/preview_front.png',
		tags: ['Websites', 'Landing pages', 'Logo Design', 'Design', 'Marketing'],
	},
	// {
	// 	projectLink: 'http://mk-electra.ru/',
	// 	cssClass: 'mk-electra',
	// 	name: 'MK-Electra',
	// 	previewText: 'Landing page on Tilda',
	// 	// previewDescription: '',
	// 	previewBgImg_back: '/img/projects/mk-electra/preview_back.jpg',
	// 	previewBgImg_front: '/img/projects/mk-electra/preview_front.png',
	// 	tags: [
	// 		'Websites',
	// 		'Tilda Development',
	// 		'Design',
	// 		'Marketing',
	// 		'Landing pages',
	// 	],
	// },
	{
		projectLink: 'https://ovik-m.ru/',
		cssClass: 'ovik',
		name: 'OViK',
		previewText: 'Corporate website',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/ovik/preview_back.jpg',
		// previewBgImg_front: '',
		tags: ['Websites', 'Landing pages', 'Design', 'Marketing'],
	},
	{
		projectLink: 'http://newalaskavolkhov.ru/',
		cssClass: 'new-alaska',
		name: 'New Alaska',
		previewText: 'Website',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/new-alaska/preview_back.jpg',
		previewBgImg_front: '/img/projects/new-alaska/preview_front.png',
		tags: ['Websites', 'Design', 'Multilingual website'],
	},
	{
		projectLink: 'https://planeta12volt.ru/',
		cssClass: 'planeta-12',
		name: 'Planet 12 volt',
		previewText: 'Car service',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/planeta12volt/preview_back.jpg',
		previewBgImg_front: '/img/projects/planeta12volt/preview_front.png',
		tags: ['Websites', 'Marketing', 'Logo Design'],
	},
	{
		projectLink: 'http://check-point.pro/',
		cssClass: 'checkpoint',
		name: 'CHECK POINT',
		previewText: 'Car service',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/checkpoint/preview_back.jpg',
		// previewBgImg_front: '',
		tags: ['Websites', 'Landing pages', 'Design', 'Marketing'],
	},
	{
		projectLink: 'http://stroysnab.com/',
		cssClass: 'stroysnab',
		name: 'Stroy Snab',
		previewText: 'Building materials store',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/stroysnab/preview_back.jpg',
		// previewBgImg_front: '',
		tags: ['Websites', 'Online Stores', 'Design', 'Marketing'],
	},
]
